import React from "react";

import { Typography } from "@material-ui/core";

import SvgI280Placeholder from "assets/icons/I280Placeholder";

import { Container } from "./styles";

type Props = { height: number; width: number; text?: string };

const Placeholder = ({ height, width, text }: Props) => (
  <Container height={height} width={width}>
    <SvgI280Placeholder viewBox={`0 0 280 280`} />
    {text && (
      <Typography variant="subtitle1" color="secondary">
        {text}
      </Typography>
    )}
  </Container>
);

export default Placeholder;
